import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=48aad156"
import script from "./FormSettings.vue?vue&type=script&lang=js"
export * from "./FormSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48aad156')) {
      api.createRecord('48aad156', component.options)
    } else {
      api.reload('48aad156', component.options)
    }
    module.hot.accept("./FormSettings.vue?vue&type=template&id=48aad156", function () {
      api.rerender('48aad156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/account-page/form-settings/FormSettings.vue"
export default component.exports